import React, { useEffect, useState } from "react";
import api, { errorMessage } from "../utils/api";
import { useAuth } from "../contexts/AuthContext";
import { formatDateTime } from "../utils/format";

const EMPTY = { email: "", name: "", password: "", role: "USER" };

export default function UsersPage() {
  const { user: me } = useAuth();
  const [users, setUsers] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api
      .get("/users")
      .then((res) => setUsers(res.data))
      .catch((err) => setError(errorMessage(err)));
  }, []);

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  async function handleAdd(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/users", form);
      setUsers([...users, data]);
      setForm(EMPTY);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  async function handleDelete(u) {
    if (!window.confirm(`${u.email} silinsin mi? QR kodları silinmez.`)) return;
    try {
      await api.delete(`/users/${u.id}`);
      setUsers(users.filter((x) => x.id !== u.id));
    } catch (err) {
      setError(errorMessage(err));
    }
  }

  return (
    <>
      <div className="page-head">
        <h1>Kullanıcılar</h1>
      </div>

      <div className="card">
        <h2>Yeni kullanıcı</h2>
        <form className="form form-inline" onSubmit={handleAdd}>
          <label>
            E-posta
            <input type="email" value={form.email} onChange={set("email")} required />
          </label>
          <label>
            İsim
            <input value={form.name} onChange={set("name")} />
          </label>
          <label>
            Şifre
            <input type="password" value={form.password} onChange={set("password")} minLength={8} required />
          </label>
          <label>
            Rol
            <select value={form.role} onChange={set("role")}>
              <option value="USER">Kullanıcı (kendi QR'ları)</option>
              <option value="SUPERADMIN">Superadmin (her şey)</option>
            </select>
          </label>
          <button className="btn btn-primary" type="submit" disabled={busy}>
            Ekle
          </button>
        </form>
      </div>

      {error && <div className="error">{error}</div>}

      {users && (
        <div className="card table-card">
          <table>
            <thead>
              <tr>
                <th>E-posta</th>
                <th>İsim</th>
                <th>Rol</th>
                <th>Oluşturulma</th>
                <th>Son giriş</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td>{u.email}</td>
                  <td>{u.name || "—"}</td>
                  <td>{u.role === "SUPERADMIN" ? "Superadmin" : "Kullanıcı"}</td>
                  <td>{formatDateTime(u.createdAt)}</td>
                  <td>{formatDateTime(u.lastLoginAt)}</td>
                  <td className="num">
                    {u.id !== me.id && (
                      <button className="btn btn-small btn-danger" onClick={() => handleDelete(u)}>
                        Sil
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
